import {TemplateType} from 'common/report/dashboards/types';

import {BreakdownType} from './types';

export enum OnboardingIndustry {
  B2B = `B2B / SaaS`,
  Consumer = `Consumer`,
  Social = `Social`,
  Media = `Media`,
  Gaming = `Gaming`,
  Education = `Education`,
  Healthcare = `Healthcare`,
  ECommerce = `E-Commerce`,
  Agency = `Agency`,
  Finance = `Finance`,
  Marketplace = `Marketplace`,
  Other = `Other`,
}

export const INDUSTRY_EVENTS = {
  b2b: {
    name: OnboardingIndustry.B2B,
    events: [`Sign Up`, `Page View`, `Request Demo`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  consumer: {
    name: OnboardingIndustry.Consumer,
    events: [`Sign Up`, `Page View`, `Create Item`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  social: {
    name: OnboardingIndustry.Social,
    events: [`Sign Up`, `Page View`, `Engage`, `Share`],
    templates: [TemplateType.KPI, TemplateType.LIFECYCLE_COHORT_ANALYSIS, TemplateType.FEATURE_LAUNCH],
  },
  media: {
    name: OnboardingIndustry.Media,
    events: [`Sign Up`, `Content View`, `Share`, `Purchase Subscription`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  gaming: {
    name: OnboardingIndustry.Gaming,
    events: [`Sign Up`, `Start Level`, `Finish level`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  education: {
    name: OnboardingIndustry.Education,
    events: [`Sign Up`, `Start Course`, `Finish Module`, `Finish Course`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  healthcare: {
    name: OnboardingIndustry.Healthcare,
    events: [`Sign Up`, `Complete Search`, `Schedule Appointment`],
    templates: [TemplateType.WEB_ANALYTICS, TemplateType.KPI, TemplateType.FEATURE_LAUNCH],
  },
  ecommerce: {
    name: OnboardingIndustry.ECommerce,
    events: [`View Item`, `Add to Cart`, `View Cart`, `Purchase Completed`],
    templates: [TemplateType.MARKETING_KPI, TemplateType.KPI, TemplateType.WEB_ANALYTICS],
  },
  agency: {
    name: OnboardingIndustry.Agency,
    events: [`Sign Up`, `Page View`],
    templates: [TemplateType.KPI, TemplateType.WEB_ANALYTICS, TemplateType.MARKETING_KPI],
  },
  finance: {
    name: OnboardingIndustry.Finance,
    events: [`Sign Up`, `Select Bank`, `Funded Account`, `Transaction`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  marketplace: {
    name: OnboardingIndustry.Marketplace,
    events: [`Sign Up`, `Page View`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
  other: {
    name: OnboardingIndustry.Other,
    events: [`Sign Up`, `Page View`],
    templates: [TemplateType.KPI, TemplateType.FEATURE_LAUNCH, TemplateType.WEB_ANALYTICS],
  },
};

export type IndustryKey = keyof typeof INDUSTRY_EVENTS;

export const PROPERTIES: {[key in BreakdownType]: string} = {device_type: `Device Type`, country: `Country`, os: `OS`};

export const PROPERTY_BREAKDOWN_MAP: {[key in BreakdownType]: [string, string]} = {
  device_type: [`Mobile`, `Desktop`],
  country: [`US`, `Europe`],
  os: [`iOS`, `Android`],
};

export const SPRIG_QUALIFIER = `OnboardingFirstImpressionSprig`;
